import React,
       { useState,
         useEffect,
         useRef                      }      from "react";
import { useLoader                   }      from "components/Covers/loadingCover";
import { useInfoMsgModal             }      from "components/Covers/infoMessageModal";
import { DateFromIsoString,
         DisplayDateAsString         }      from "components/Date/date";
import  MainStyle                           from "components/UI/main.module.scss";
import { useNavigate                  }     from "react-router-dom";
import { InputGeneral                }      from "components/Field/field";
import { AgGridReact                  }     from "ag-grid-react";
import {AllCommunityModule,ModuleRegistry}  from 'ag-grid-community';
import { AG_GRID_LOCALE_BR            }     from '@ag-grid-community/locale';
import { Select,
         Tooltip
                       }     from "antd";
import { DefaultLoadingLogo,
         Heimdall,
         GetLabel,
         GetAppLang,
         SetLastFeature,
         toSafeFilename               }     from "Utilities/utils";
import { getOrderList,
         getFilterMeta,
         getClassSpreadSheet          }     from "./Report_Class_Service";
import   dayjs                              from "dayjs";

// #region Object Template

let blank_search_param_obj = {
    CLASS_IDS         : [],
    SCHOOL_IDS        : [],
    AREA_IDS          : [],
    PROGRAM_IDS       : [],
    CLIENT_IDS        : [],
    ACADEMIC_AREA_IDS : [],
    USER_IDS          : [],
};
let blank_meta_param_obj = {
    CLASS_LIST        : [],
    SCHOOL_LIST       : [],
    AREA_LIST         : [],
    PROGRAM_LIST      : [],
    CLIENT_LIST       : [],
    ACADEMIC_AREA_LIST: [],
    USER_LIST         : [],
};
let appLang = GetAppLang();
// #endregion

// #region Download
//  Decodifica o base64 devolvido pelo backend e dispara o download.
function downloadExcelFromBase64(base64, fileName) {
    const byteCharacters    = atob(base64);
    const byteNumbers       = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob      = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const blobUrl   = URL.createObjectURL(blob);

    const a         = document.createElement("a");
    a.href          = blobUrl;
    a.download      = fileName;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(blobUrl);
}
// #endregion

// #region Layout Helppers
const DropdownList = ({
    className,
    style,
    onChange,
    onSearch,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value,
    mode,
    maxTagCount,
  }) => {
    return (
      <Select
        showSearch
        allowClear
        mode={mode}
        maxTagCount={maxTagCount}
        id={id}
        name={name}
        value={value} 
        placeholder={placeholder}
        className={className}
        style={style}
        title={title}
        popupClassName={popupClassName}
        options={listOfItems}
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        onChange={(val, option) => {
          onChange?.(val, option); // lift change to parent
        }}
        onSearch={(val) => {
          onSearch?.(val);
        }}
        notFoundContent={null}
      />
    );
};
const DefaultPadding = () =>{
    return(<div className={MainStyle.py_3}/>);
};

const HTooltip = React.memo(({...other}) =>{
    const { text } = other;

    if (!text) {return null;} 

    return (
        <Tooltip title={text} placement="top">
            <span
                role="button"
                tabIndex={0}
                aria-label={text}
                style={{cursor: 'pointer'}}
                className={[MainStyle.d_inline_flex, MainStyle.align_items_center, MainStyle.ms_1].join(" ")}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    aria-hidden="true"
                    focusable="false"
                    className={[MainStyle.small_ico_generic, MainStyle.small_ico_generic_style].join(" ")}
                >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
                </svg>
            </span>
        </Tooltip>
    );
});

function firstId(ids) {
    return (ids && ids.length > 0) ? ids[0] : null;
}
function getSchoolChoices(meta) {
    return meta?.SCHOOL_LIST ?? [];
}
function getAreaChoices(meta, param) {
    const schoolId = firstId(param?.SCHOOL_IDS);
    const list     = meta?.AREA_LIST ?? [];
    if (schoolId === null) { return list; }
    return list.filter((i) => i.SCHOOL_ID === schoolId);
}
function getProgramChoices(meta, param) {
    const schoolId = firstId(param?.SCHOOL_IDS);
    const areaId   = firstId(param?.AREA_IDS);
    let list       = meta?.PROGRAM_LIST ?? [];
    if (schoolId !== null) { list = list.filter((i) => i.SCHOOL_ID === schoolId); }
    if (areaId   !== null) { list = list.filter((i) => i.AREA_ID   === areaId); }
    return list;
}
function getClassChoices(meta, param) {
    const programId = firstId(param?.PROGRAM_IDS);
    const list      = meta?.CLASS_LIST ?? [];

    if (programId !== null) {
        return list.filter((i) => i.PROGRAM_ID === programId);
    }
    if (firstId(param?.SCHOOL_IDS) === null && firstId(param?.AREA_IDS) === null) {
        return list;
    }
    const allowed = getProgramChoices(meta, param).map((i) => i.PROGRAM_ID);
    return list.filter((i) => allowed.some((p) => p === i.PROGRAM_ID));
}
function pruneIncoherent(meta, param) {
    const next = {...param};

    const areaId = firstId(next.AREA_IDS);
    if (areaId !== null && !getAreaChoices(meta, next).some((i) => i.AREA_ID === areaId)) {
        next.AREA_IDS = [];
    }
    const programId = firstId(next.PROGRAM_IDS);
    if (programId !== null && !getProgramChoices(meta, next).some((i) => i.PROGRAM_ID === programId)) {
        next.PROGRAM_IDS = [];
    }
    const classId = firstId(next.CLASS_IDS);
    if (classId !== null && !getClassChoices(meta, next).some((i) => i.CLASS_ID === classId)) {
        next.CLASS_IDS = [];
    }
    return next;
}

const FilterSingleSelect = React.memo(({...other}) => {
    const { paramKey,
            title,
            placeholder,
            options,
            searchMetaParam,
            resetKeys,
            searchParam,
            setSearchParam  } = other;

    const selected = firstId(searchParam?.[paramKey]);

    const ChangeItem = (d) => {
        const value = (d === undefined || d === null) ? [] : [d];
        setSearchParam(prevState => pruneIncoherent(searchMetaParam, {...prevState, [paramKey]: value}));
    };

    useEffect(() => {},[searchParam, setSearchParam]);

    return (
        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg}>
                <div className={MainStyle.border_bottom}>
                    <div className={MainStyle.my_2}>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg}>
                                <div className={[MainStyle.mx_3].join(" ")}>
                                    <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                        {title}
                                    </span>
                                    <DropdownList
                                        value={selected !== null ? selected : undefined}
                                        placeholder={placeholder}
                                        listOfItems={options}
                                        style={{ width: "100%" }}
                                        className={[MainStyle.mt_2].join(" ")}
                                        onChange={(event) => {ChangeItem(event)}}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

const QuestionMultiSelect = React.memo(({...other}) => {
    const { options,
            selectedIds,
            setSelectedIds  } = other;

    const allSelected = options.length > 0 && selectedIds.length === options.length;

    return (
        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg}>
                <div className={MainStyle.border_bottom}>
                    <div className={MainStyle.my_2}>
                        <div className={[MainStyle.mx_3].join(" ")}>
                            <div className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.justify_content_between].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                    {`${GetLabel(appLang, 677)} (${selectedIds.length}/${options.length})`}
                                </span>
                                {
                                    !allSelected &&
                                        <button
                                            className={[MainStyle.btn_vanilla,
                                                        MainStyle.border,
                                                        MainStyle.rounded_3,
                                                        MainStyle.fs_8,
                                                        MainStyle.text_body,
                                                        MainStyle.py_1,
                                                        MainStyle.px_2].join(" ")}
                                            onClick={() => {setSelectedIds(options.map((item) => item.value))}}
                                        >
                                            {GetLabel(appLang, 686)}
                                        </button>
                                }
                            </div>
                            <DropdownList
                                mode="multiple"
                                maxTagCount="responsive"
                                value={selectedIds}
                                placeholder={GetLabel(appLang, 665)}
                                listOfItems={options}
                                style={{ width: "100%" }}
                                className={[MainStyle.mt_2].join(" ")}
                                onChange={(event) => {setSelectedIds(event ?? [])}}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});


const FilterOptions = React.memo(({...props}) => {
    const { searchMetaParam,
            searchParam,
            setSearchParam  }      = props;

    useEffect(() => {},[searchMetaParam, searchParam]);

    const schoolOptions = getSchoolChoices(searchMetaParam).map((i) => (
        {value: i.SCHOOL_ID, label: i.SCHOOL_DESC}
    ));
    const areaOptions = getAreaChoices(searchMetaParam, searchParam).map((i) => (
        {value: i.AREA_ID, label: i.AREA_DESC}
    ));
    const programOptions = getProgramChoices(searchMetaParam, searchParam).map((i) => (
        {value: i.PROGRAM_ID, label: i.PROGRAM_DESC}
    ));
    const classOptions = getClassChoices(searchMetaParam, searchParam).map((i) => (
        {value: i.CLASS_ID, label: i.CLASS_DESC}
    ));

    return (
        searchMetaParam ? (
            <React.Fragment>
                {/*          School         */}
                <FilterSingleSelect
                    paramKey="SCHOOL_IDS"
                    title={GetLabel(appLang, 318)}
                    placeholder={GetLabel(appLang, 379)}
                    options={schoolOptions}
                    searchMetaParam={searchMetaParam}
                    searchParam={searchParam}
                    setSearchParam={setSearchParam}
                />
                {/*          Area           */}
                <FilterSingleSelect
                    paramKey="AREA_IDS"
                    title={GetLabel(appLang, 319)}
                    placeholder={GetLabel(appLang, 380)}
                    options={areaOptions}
                    searchMetaParam={searchMetaParam}
                    searchParam={searchParam}
                    setSearchParam={setSearchParam}
                />
                {/*         Program         */}
                <FilterSingleSelect
                    paramKey="PROGRAM_IDS"
                    title={GetLabel(appLang, 321)}
                    placeholder={GetLabel(appLang, 381)}
                    options={programOptions}
                    searchMetaParam={searchMetaParam}
                    searchParam={searchParam}
                    setSearchParam={setSearchParam}
                />
                {/*     Class (required)    */}
                <FilterSingleSelect
                    paramKey="CLASS_IDS"
                    title={`${GetLabel(appLang, 661)}*`}
                    placeholder={GetLabel(appLang, 672)}
                    options={classOptions}
                    searchMetaParam={searchMetaParam}
                    searchParam={searchParam}
                    setSearchParam={setSearchParam}
                />
                
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_vanilla,
                                            MainStyle.rounded_3,
                                            MainStyle.border,
                                            MainStyle.shadow_sm,
                                            MainStyle.fs_6,
                                            MainStyle.text_body,
                                            MainStyle.py_3,
                                            MainStyle.px_3].join(" ")}
                                onClick={async () => {
                                    setSearchParam({...blank_search_param_obj});
                                }}
                            >
                                {GetLabel(appLang, 239)}
                            </button>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
        :
        (
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg}>
                    <div style={{height: '10rem'}} className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.my_5].join(" ")}>
                        <div style={{zIndex: "1"}} className={[MainStyle.small_loading_circle].join(" ")}/>
                    </div>
                </div>
            </div>
        )
    );

});
// #endregion


const Drawer = React.memo(({children}) => {
    const [ expanded,  setExpanded  ] = useState(false);
    const [ maxHeight, setMaxHeight ] = useState(0);   // em px
    const contentRef                  = useRef(null);

    useEffect(() => {
        const el = contentRef.current;
        if (!el) { return; }

        const measure = () => {
            setMaxHeight(expanded ? el.scrollHeight : 0);
        };
        measure();

        if (!expanded) { return; }
        if (typeof ResizeObserver === "undefined") { return; }

        const observer = new ResizeObserver(measure);
        observer.observe(el);
        return () => observer.disconnect();
    }, [expanded, children]);

    const handleClick = () => {
        setExpanded(prev => !prev);
    };

    return (
        <div className={[MainStyle.bg_card_item, MainStyle.shadow_sm, MainStyle.border, MainStyle.rounded].join(" ")}>
            <div className={[MainStyle.d_flex,
                             expanded ? MainStyle.bg_header_item : MainStyle.bg_card_item,
                             MainStyle.rounded_top].join(" ")}>
                <div className={[MainStyle.align_self_center]}>
                    <span className={[MainStyle.mx_3,
                                      expanded ? MainStyle.text_white : MainStyle.text_body,
                                      MainStyle.fw_semibold].join(" ")}>
                        {GetLabel(appLang, 547)}
                    </span>
                </div>
                <div className={[MainStyle.ms_auto].join(" ")}>
                    <div
                        onClick={() => {handleClick();}}
                        className={[MainStyle.shadow_sm,
                                    expanded ? MainStyle.rounded_top : MainStyle.rounded_top_end_bottom_end_1,
                                    MainStyle.table_btn_icon,
                                    MainStyle.text_center,
                                    MainStyle.p_3,
                                    MainStyle.ms_1].join(" ")}>
                        <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                            {expanded ?
                                <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>
                            :
                                <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
                            }
                        </svg>
                    </div>
                </div>
            </div>
            <div
                style={{
                    maxHeight: `${maxHeight}px`,
                    overflow: 'hidden',
                    transition: 'max-height 0.25s ease',
                }}
                className={expanded ? MainStyle.bg_theme : undefined}
            >
                <div ref={contentRef}>
                    {children}
                </div>
            </div>
        </div>
    );
});

function IsOrderCollecting(order) {
    if (order?.STATUS_ID === 5) { return false; }
    const c = dayjs();
    const i = DateFromIsoString(order?.OPENING);
    const f = DateFromIsoString(order?.CLOSING);
    return ((c > i) && (c < f));
}

const StatusLabel = React.memo(({...other}) => {
    const { status, dt0, dt1 } = other;
    let c = dayjs();
    let i = DateFromIsoString(dt0);
    let f = DateFromIsoString(dt1);
    let style = [MainStyle.border, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center, MainStyle.rounded_3];
    let label = "";
    if (status === 5) {
        style.push(MainStyle.bg_success, MainStyle.text_white);
        label = GetLabel(appLang, 97);
    }
    else {
        if (IsOrderCollecting({STATUS_ID: status, OPENING: dt0, CLOSING: dt1})) {
            style.push(MainStyle.bg_warning, MainStyle.text_black);
            label = GetLabel(appLang, 526);
        }
        else if ((c > i) && (c > f)) {
            style.push(MainStyle.bg_success, MainStyle.text_white);
            label = GetLabel(appLang, 98);
        }
        else {
            style.push(MainStyle.bg_success, MainStyle.text_white);
            label = GetLabel(appLang, 99);
        }
    }
    return (
        <div style={{width: '5.0rem'}} className={style.join(" ")}>
            <span className={[MainStyle.fs_7, MainStyle.p_1].join(" ")}>
                {label}
            </span>
        </div>
    );
});

const CollectingWarning = React.memo(({...other}) => {
    const { count } = other;

    if (!count || count <= 0) { return null; }

    return (
        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg}>
                <div className={[MainStyle.bg_warning, MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded_3, MainStyle.my_3, MainStyle.p_2].join(" ")}>
                    <div className={[MainStyle.d_flex, MainStyle.align_items_center].join(" ")}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            className={[MainStyle.small_ico_generic, MainStyle.mx_2].join(" ")}
                        >
                            <path style={{fill: "#000"}} d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/>
                        </svg>
                        <span className={[MainStyle.fs_7, MainStyle.text_black, MainStyle.mx_1].join(" ")}>
                            {GetLabel(appLang, 675)} ({count})
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
});

const ResultHeader = React.memo(({...other}) => {
    return (
        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg}>
                <div className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.border_bottom, MainStyle.mx_3, MainStyle.mt_3, MainStyle.pb_2].join(" ")}>
                    <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                        {GetLabel(appLang, 689)}
                    </span>
                </div>
            </div>
        </div>
    );
});

//  Listagem das avaliacoes das turmas selecionadas.
const OrderList = React.memo(({...other}) => {
    const { orderList }                   = other;
    const [ searchText,  setSearchText  ] = useState('');
    const gridRef                         = useRef();

    ModuleRegistry.registerModules([AllCommunityModule]);

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 10, // Number of rows per page
        paginationPageSizeSelector: [10, 20, 50, 100],
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true,
    };

    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    //  Datas renderizadas com DisplayDateAsString, o mesmo formato que a
    //  tela ja exibia antes do grid, para a troca nao mudar a aparencia
    //  do que o usuario le.
    const DateCell = (params) => {
        return (
            <span className={[MainStyle.text_body, MainStyle.fs_7].join(" ")}>
                {DisplayDateAsString(params.value)}
            </span>
        );
    };

    const columnDefs = [
        {
            headerName: GetLabel(appLang, 572),
            marryChildren: true,
            children: [
                { headerName: GetLabel(appLang, 35),  field: "ORDER_CODE",   filter: true, flex: 0, width: 140,
                cellClass: [MainStyle.table_text_left].join(" ") },
                { headerName: GetLabel(appLang, 36),  field: "ORDER_DESC",   filter: true, flex: 1, minWidth: 240,
                cellClass: [MainStyle.table_text_left].join(" ") },
                { headerName: GetLabel(appLang, 37),  field: "OPENING", colId: "STATUS",
                filter: false, flex: 0, width: 140,
                cellRenderer: (params) => {
                    return (
                        <StatusLabel
                            status={params.data?.STATUS_ID}
                            dt0={params.data?.OPENING}
                            dt1={params.data?.CLOSING}
                        />
                    );
                },
                cellClass: [MainStyle.table_text_center].join(" "),
                headerClass: MainStyle.table_header_center },
            ]
        },
        {
            headerName: GetLabel(appLang, 573),
            marryChildren: true,
            children: [
                
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 318),    field: "SCHOOL_DESC"  ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 319),    field: "AREA_DESC"    ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 321),    field: "PROGRAM_DESC" ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 674), field: "CLASSES_DESC", filter: true, flex: 1, minWidth: 200,
                cellClass: [MainStyle.table_text_left].join(" ") }
            ]
        },
        {
            headerName: GetLabel(appLang, 574),
            marryChildren: true,
            children: [
                { headerName: GetLabel(appLang, 38),  field: "OPENING",      filter: true, flex: 0, width: 180,
                cellRenderer: DateCell, cellClass: [MainStyle.table_text_left].join(" ") },
                { headerName: GetLabel(appLang, 39),  field: "CLOSING",      filter: true, flex: 0, width: 180,
                cellRenderer: DateCell, cellClass: [MainStyle.table_text_left].join(" ") },
                { headerName: GetLabel(appLang, 528), field: "SUBMISSIONS",  filter: true, flex: 0, width: 140,
                cellClass: [MainStyle.table_text_center].join(" "), headerClass: MainStyle.table_header_center },
            ]
        },
    ];

    //  Conta quantas avaliacoes da lista ainda estao em coleta.
    const collectingCount = orderList ? orderList.filter((item) => IsOrderCollecting(item)).length : 0;

    return (
        orderList && (
            <React.Fragment>
            <ResultHeader count={orderList.length}/>
            {
            orderList.length > 0 ?
                <div className={[MainStyle.row, MainStyle.bg_theme, MainStyle.border].join(" ")}>
                    <div className={MainStyle.col_lg}>
                        <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg_9}/>
                                <div className={MainStyle.col_lg_3}>
                                    <div className={[MainStyle.d_flex].join(" ")}>
                                        <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 512 512"
                                                className={MainStyle.small_ico_search_bar}
                                            >
                                                <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                            </svg>
                                        </div>
                                        {/*  Report_0 usa MainStyle.border_1 aqui, mas
                                             essa classe nao existe no scss e vira
                                             "undefined" no className. Usando border.  */}
                                        <InputGeneral
                                            value={searchText}
                                            className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border, MainStyle.mb_3].join(" ")}
                                            onChange={onQuickFilterChanged}
                                            placeholder={GetLabel(appLang, 33)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ height: '40rem'}}>
                            <AgGridReact
                                ref={gridRef}
                                rowData={orderList}
                                columnDefs={columnDefs}
                                gridOptions={gridOptions}
                                quickFilterText={searchText}
                            />
                        </div>
                        <CollectingWarning count={collectingCount}/>
                    </div>
                </div>
            :
                <div className={[MainStyle.row, MainStyle.bg_theme, MainStyle.border].join(" ")}>
                    <div className={MainStyle.col_lg}>
                        <div className={[MainStyle.text_center, MainStyle.my_3].join(" ")}>
                            <span className={[  MainStyle.fs_7,
                                                MainStyle.text_body].join(" ")}>
                                {GetLabel(appLang, 548)}
                            </span>
                        </div>
                    </div>
                </div>
            }
            </React.Fragment>
        )
    );

});
const ExportPanel = React.memo(({...other}) => {
    const { questionList,
            orderList,
            searchParam     }   = other;

    const [ exportParam, setExportParam ]   = useState({ 
        QUESTION_IDS: [],
        COURSE_SOURCE:     "INTERNAL",
        DEPARTMENT_SOURCE: "INTERNAL", 
    });
    const { showLoader,  hideLoader     }   = useLoader();
    const { showInfoMessage             }   = useInfoMsgModal();

    //  Toda vez que chega uma lista nova de questoes, marca todas.
    //  Assim o comportamento padrao reproduz o modelo: quem nao mexer
    //  no filtro recebe a planilha com todas as questoes.
    useEffect(() => {
        setExportParam(prevState => ({
            ...prevState,
            QUESTION_IDS: (questionList ?? []).map((item) => item.QUESTION_ID),
        }));
    }, [questionList]);

    const setSource = (key, value) => {
        setExportParam(prevState => ({...prevState, [key]: value}));
    };
    const setSelectedQuestions = (ids) => {
        setExportParam(prevState => ({...prevState, QUESTION_IDS: ids}));
    };
    
    //  O rotulo do grupo entra junto para o usuario distinguir questoes
    //  de texto parecido que pertencem a secoes diferentes.
    const options = (questionList ?? []).map((item) => ({
        value: item.QUESTION_ID,
        label: item.GROUP_DESC
                    ? `${item.GROUP_DESC} ${item.QUESTION_DESC}`
                    : item.QUESTION_DESC,
    }));

    async function ExportData() {
        if (!exportParam?.QUESTION_IDS?.length) {
            showInfoMessage({header: GetLabel(appLang, 54), message: GetLabel(appLang, 680)});
            return;
        }

        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});

        let data = await getClassSpreadSheet({
            ...searchParam,
            QUESTION_IDS:      exportParam.QUESTION_IDS,
            COURSE_SOURCE:     exportParam.COURSE_SOURCE,
            DEPARTMENT_SOURCE: exportParam.DEPARTMENT_SOURCE,
            APP_LANG:          appLang,
        });

        if (data) {
            if (data?.status?.statusCode == 0) {
                data = data.response.content;
                downloadExcelFromBase64(data.DATA, buildFileName(orderList));
                hideLoader();
            }
            else {
                hideLoader();
                showInfoMessage({header: GetLabel(appLang, 107), message: data.status.message});
            }
        }
        else {
            hideLoader();
            showInfoMessage({header: GetLabel(appLang, 107), message: GetLabel(appLang, 531)});
        }
    }

    //  Sem questao de classificacao nas avaliacoes nao ha o que exportar.
    if (!questionList || questionList.length === 0) {
        return (
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg}>
                    <div className={[MainStyle.text_center, MainStyle.my_3].join(" ")}>
                        <span className={[MainStyle.fs_7, MainStyle.text_body].join(" ")}>
                            {GetLabel(appLang, 681)}
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={[MainStyle.row, MainStyle.bg_card_item, MainStyle.border, MainStyle.rounded, MainStyle.my_3].join(" ")}>
            <div className={MainStyle.col_lg}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_6}>
                        <SourceToggle
                            tooltip={GetLabel(appLang, 688)}    
                            title={GetLabel(appLang, 684)}
                            value={exportParam.COURSE_SOURCE}
                            onChange={(value) => {setSource("COURSE_SOURCE", value)}}
                        />
                    </div>
                    <div className={MainStyle.col_lg_6}>
                        <SourceToggle
                            tooltip={GetLabel(appLang, 687)}
                            title={GetLabel(appLang, 685)}
                            value={exportParam.DEPARTMENT_SOURCE}
                            onChange={(value) => {setSource("DEPARTMENT_SOURCE", value)}}
                        />
                    </div>
                </div>
                <QuestionMultiSelect
                    options={options}
                    selectedIds={exportParam.QUESTION_IDS}
                    setSelectedIds={setSelectedQuestions}
                />
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_9}/>
                    <div className={MainStyle.col_lg_3}>
                        <div className={MainStyle.m_3}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_green,
                                            MainStyle.rounded_3,
                                            MainStyle.border,
                                            MainStyle.shadow_sm,
                                            MainStyle.fs_7,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_3].join(" ")}
                                onClick={async () => {ExportData()}}
                            >
                                {GetLabel(appLang, 676)}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

//  Nome do arquivo baixado. Usa a turma da primeira avaliacao da lista,
//  que e a informacao que identifica o relatorio para quem recebe.
function buildFileName(orderList) {
    const turma = orderList?.[0]?.CLASSES_DESC ?? "";
    const base  = turma ? toSafeFilename(turma) : "Survey_Class_Report";
    return `${base}_${Date.now()}.xlsx`;
}

const SearchBlock =  React.memo(({...other}) => {
    const { searchMetaParam                     }   = other;
    const [ searchParam, setSearchParam         ]   = useState(blank_search_param_obj);
    const { showInfoMessage                     }   = useInfoMsgModal(); // Modal message control
    const [ questionList, setQuestionList       ]   = useState(null);
    const [ appliedParam, setAppliedParam       ]   = useState(null);
    const [ orderList,   setOrderList           ]   = useState(null);
    const { showLoader,  hideLoader             }   = useLoader();

    async function SearchData() {
        if (searchParam?.CLASS_IDS?.length == 0) {
            showInfoMessage({header: GetLabel(appLang, 54), message: GetLabel(appLang, 673)});
            return;
        }
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let data = await getOrderList(searchParam);
        if (data) {
            if (data?.status?.statusCode == 0) {
                data = await data.response.content;
                setOrderList(data?.ORDER_LIST ?? []);
                setQuestionList(data?.QUESTION_LIST ?? []);
                setAppliedParam({...searchParam});
                hideLoader();
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
            }
        }
        else {
            hideLoader();
            showInfoMessage({'header': GetLabel(appLang, 107), 'message': GetLabel(appLang, 531)});
        }

    }

    useEffect(() => {}, [searchMetaParam]);


    
return (
    <div className={MainStyle.col_lg}>

        {/* Container 1: Parâmetros */}
        <div
            className={[
                MainStyle.bg_card,
                MainStyle.shadow,
                MainStyle.border,
                MainStyle.rounded
            ].join(" ")}
            style={{ marginBottom: "24px", padding: "16px" }}
        >
            <Drawer>
                <FilterOptions
                    searchMetaParam={searchMetaParam}
                    searchParam={searchParam}
                    setSearchParam={setSearchParam}
                />
            </Drawer>

            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_10} />
                <div className={MainStyle.col_lg_2}>
                    <div className={MainStyle.m_3}>
                        <button
                            style={{ width: "100%" }}
                            className={[
                                MainStyle.btn_blue,
                                MainStyle.rounded_3,
                                MainStyle.border,
                                MainStyle.shadow_sm,
                                MainStyle.fs_7,
                                MainStyle.text_white,
                                MainStyle.py_3,
                                MainStyle.px_3
                            ].join(" ")}
                            onClick={async () => { SearchData() }}
                        >
                            {GetLabel(appLang, 550)}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        {/* Container 2: Resultados */}
        <div
            className={[
                MainStyle.bg_card,
                MainStyle.shadow,
                MainStyle.border,
                MainStyle.rounded
            ].join(" ")}
            style={{ padding: "16px" }}
        >
            <OrderList orderList={orderList} />

            {/* Exportação disponível após a consulta */}
            {orderList && orderList.length > 0 &&
                <ExportPanel
                    questionList={questionList}
                    orderList={orderList}
                    searchParam={appliedParam}
                />
            }
        </div>

        <DefaultPadding />
    </div>
);
});

const SourceToggle = React.memo(({...other}) => {
    const { title,
            tooltip,
            value,
            onChange    } = other;

    function toggleButton(optionValue, optionLabel) {
        const selected = value === optionValue;
        return (
            <button
                key={`source_${title}_${optionValue}`}
                style={{width: '50%'}}
                className={[selected ? MainStyle.btn_blue : MainStyle.btn_vanilla,
                            MainStyle.border,
                            MainStyle.fs_7,
                            selected ? MainStyle.text_white : MainStyle.text_body,
                            MainStyle.py_2,
                            MainStyle.px_2].join(" ")}
                onClick={() => {onChange(optionValue)}}
            >
                {optionLabel}
            </button>
        );
    }

    return (
        <div className={[MainStyle.mx_3, MainStyle.my_2].join(" ")}>
            <div className={[MainStyle.d_flex, MainStyle.align_items_center].join(" ")}>
                <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                    {title}
                </span>
                <HTooltip text={tooltip}/>
            </div>
            <div className={[MainStyle.d_flex, MainStyle.rounded_3, MainStyle.overflow_hidden, MainStyle.shadow_sm, MainStyle.mt_2].join(" ")}>
                {toggleButton("INTERNAL", GetLabel(appLang, 682))}
                {toggleButton("EXTERNAL", GetLabel(appLang, 683))}
            </div>
        </div>
    );
});

const Report = React.memo(({...other}) => {
    const { setScreen,
            searchMetaParam,            } = other;


    useEffect(() => {
    },[searchMetaParam, setScreen]);

    return (
        <React.Fragment>
            <DefaultPadding/>
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <DefaultPadding/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.my_3}>
                            <SearchBlock searchMetaParam={searchMetaParam}/>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
});

export const Report_Class_Page = () => {
    const [ screenType,     setScreenType       ]   = useState(1);
    const navigate                                  = useNavigate();
    const [ searchMetaParam, setSearchMetaParam ]   = useState(null);

    useEffect(() => {
        if (!Heimdall([25])) {
            navigate('/home');
        }
        else {
            SetLastFeature(25);
        }
        const fetchFilterData = async () => {
            let data = await getFilterMeta();
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    setSearchMetaParam(data);
                }
                else {
                    setSearchMetaParam(blank_meta_param_obj);
                }
            }
            else {
                setSearchMetaParam(blank_meta_param_obj);
            }
        };
        fetchFilterData();
    }, [screenType]);

    return (
        <React.Fragment>
        {
        screenType == 1?
            <React.Fragment>
                <DefaultPadding/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_12}>
                        <div className={[MainStyle.mx_3].join(" ")}>
                            <Report
                                searchMetaParam={searchMetaParam}
                                setScreen={setScreenType}
                            />
                        </div>
                    </div>
                </div>
                <DefaultPadding/>
            </React.Fragment>
        :
            null
        }
        </React.Fragment>
    );
};
